<template>
  <TemplateDefault
    :has-global-navigation="false"
    :has-search-form="false"
    :has-timeline="false">
    <template #contentsHeader>
      <SearchContentsHeader
        :categories="CATEGORIES"
        :query-keys="QUERY_KEYS"
        :result-total="resultTotal"
        @update:search-word="searchWord = $event"
        @update:current-tab-key="onUpdateCurrentTabKey($event)" />
    </template>
    <template #main>
      <SearchIndexMain
        :search-word="searchWord"
        :categories="CATEGORIES"
        :current-tab-key="currentTabKey"
        :query-keys="QUERY_KEYS"
        @update:result-total="resultTotal = $event" />
    </template>
    <template #asideSecondary>
      <SearchIndexAsideSecondary />
    </template>
  </TemplateDefault>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import SearchIndexMain from './Main.vue'
import SearchIndexAsideSecondary from './AsideSecondary.vue'
import SearchContentsHeader from './ContentsHeader.vue'
import type { Ref } from 'vue'

export default defineComponent({
  name: 'SearchIndexApp',

  components: {
    SearchIndexMain,
    SearchIndexAsideSecondary,
    SearchContentsHeader,
  },

  setup() {
    // constants
    const QUERY_KEYS = {
      KEYWORD: 'keyword',
      FILTER: 'filter',
    } as const

    const CATEGORIES = {
      index: {
        key: 'index',
        label: 'すべて',
      },
      keyword: {
        key: 'keyword',
        label: '用語解説',
      },
      report: {
        key: 'report',
        label: 'BizHint独占記事',
      },
      article: {
        key: 'article',
        label: 'ニュース記事',
      },
      document: {
        key: 'document',
        label: '事例記事・資料',
      },
    } as const

    const searchWord = ref('')
    const resultTotal = ref(0)
    const currentTabKey: Ref<SearchCategory> = ref(CATEGORIES.index.key)

    const onUpdateCurrentTabKey = (value: SearchCategory) => {
      currentTabKey.value = value
    }

    return {
      // constants
      QUERY_KEYS,
      CATEGORIES,

      // data
      searchWord,
      resultTotal,
      currentTabKey,

      // methods
      onUpdateCurrentTabKey,
    }
  }
})
</script>

